import { IPaymentWorkflowStudent } from "@/interfaces/IPaymentWorkflowStudent";

export class State {
  selectedClassicPayStudents: Array<any> = [];
  selectedFlashPayStudents: Array<any> = [];
  selectedAutomaticPaymentStudent: any = null;
  selectedCostBearerClassicPayStudents: Array<IPaymentWorkflowStudent> = [];
  selectedCostBearerSingleStudent: any = null;
}
